import React from 'react'
import Layout from '../components/Layout'
import LegislationCountry from '../components/Legislation/LegislationCountry'
import CommonBanner from '../components/CommonBanner'
import { useTranslation } from "react-i18next"; 

function Legislation() {
  const { t } = useTranslation();
  return (
    <Layout>
      <CommonBanner title={t("legislation:title","Legislation")} />
      <LegislationCountry />
    </Layout>
  )
}

export default Legislation